import React from 'react'

import { Field } from 'formik'

import { Form, Col, Button } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

import { NuevoActualizarTablaPersonalizadaModal } from 'sharedComponents/modals'

const IdServicioFormGroup = ({ iError, iTouched, fIsSubmitting, handleChange, setFieldValue }) => {
  const [servicios, setServicios] = React.useState([])
  const [mostrarModalCrud, setMostrarModalCrud] = React.useState(false)

  React.useEffect(() => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.TALLERSERVICIO).then(({ data }) => {
      setServicios(data)
    })
  }, [])

  const onSuccess = React.useCallback(async () => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.TALLERSERVICIO).then(({ data }) => {
      setServicios(data)
    })
    setMostrarModalCrud(false)
  }, [])

  const onChange = React.useCallback(
    e => {
      handleChange(e)
      setFieldValue('_idSubServicio1', '')
      setFieldValue('_idSubServicio2', '')
    },
    [handleChange, setFieldValue]
  )

  return (
    <>
      <Form.Group>
        <Form.Label text='SERVICIO' htmlFor='select-idServicio' md={2} alignRightAt='md' />
        <Col md={10}>
          <Form.InputGroup>
            <Field name='_idServicio'>
              {({ field }) => (
                <Form.Select {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-idServicio' onChange={onChange}>
                  <option key='seleccionar' value=''>
                    Seleccionar
                  </option>
                  {servicios.map(x => (
                    <option key={x._id} value={x._id}>
                      {x.nombre}
                    </option>
                  ))}
                </Form.Select>
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button onClick={() => setMostrarModalCrud(true)}>+</Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarModalCrud && (
        <NuevoActualizarTablaPersonalizadaModal
          handleClose={e => setMostrarModalCrud(false)}
          show={mostrarModalCrud}
          modalData={{}}
          onSuccess={onSuccess}
          tipoTabla={TiposTablaPersonalizadaConstant.TALLERSERVICIO}
        />
      )}
    </>
  )
}

export default React.memo(IdServicioFormGroup)
